export default {
  isNum(val: any): boolean {
    return typeof val === "number" && !isNaN(val) && isFinite(val);
  },

  isEmpty(val: any): boolean {
    return val === undefined || val === null || val === "";
  },

  /**
   * 恢复默认数据
   */
  reAssign(
    target: { [index: string]: any },
    defData: { [index: string]: any }
  ) {
    if (!target || !defData) return;
    for (const key in defData) {
      if (this.isEmpty(target[key])) {
        target[key] = defData[key];
      }
    }
    return target;
  },
};
